<template>
  <div class="info-container">
    <div class="navigation">
      <button class="button" v-on:click="setup" tabindex="0" ref="n1">
        SLIDESHOWS
      </button>
      <button class="button" v-on:click="appInfo" tabindex="1" ref="n2">
        APP INFO
      </button>
    </div>

    <div class="line-item">
      App Version: {{PS.appVersion}}
    </div>

    <div class="line-item">
      Contact Us: support@powerslide.app
    </div>

    <button class="button logout" v-on:click="logout" tabindex="2">
      LOGOUT
    </button>

    <div class="copyright">
      &#169; PowerSlide 2022
    </div>
  </div>
</template>

<script>
import '../styles/base.css'

export default {
  name: 'AppInfo',
  data () {
    return {

    }
  },

  mounted () {
    const n2 = this.$refs.n2
    n2.focus()
  },

  methods: {
    appInfo: function () {
      if (this.$route.path !== '/app-info') {
        this.$router.push('/app-info')
      }
    },

    logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    },

    setup: function () {
      if (this.$route.path !== '/setup') {
        this.$router.push('/setup')
      }
    }
  }
}
</script>

<style scoped>
  .line-item {
    color: white;
    font-size: 1em;
    padding: 1em;
  }

  .button {
    font-size: 1em;
    outline: none;
    padding: .75em;
    width: 150px;
  }

  .copyright {
    bottom: 0;
    color: white;
    font-size: .75em;
    padding: 1em;
    position: fixed;
    width: 100%;
  }

  .info-container {
    background: black;
    height: 100%;
    min-height: 100vh;
    text-align: center;
  }

  .logout {
    margin-top: 1em;
  }

  .navigation {
    background: var(--secondary);
    text-align: center;
    width: 100vw;
  }

  .nav-item {
    display: inline-block;
    padding: 1em;
  }
</style>
